import { RefObject, useCallback, useEffect } from 'react';

export const useMaxSizeForViewport = (
  container: RefObject<HTMLElement>,
  offset: number
) => {
  const calculateDimensions = useCallback(() => {
    const element = container.current;
    if (!element) return;
    const offsetTop = element.getBoundingClientRect().top;
    const remainingHeight = window.innerHeight - offsetTop;
    const containerHeight = remainingHeight - offset;
    element.style.height = `${containerHeight}px`;
  }, [container, offset]);

  useEffect(() => {
    window.addEventListener('resize', calculateDimensions);
    return () => {
      window.removeEventListener('resize', calculateDimensions);
    };
  }, [calculateDimensions]);

  useEffect(() => {
    calculateDimensions();
  });
};
